import z from 'zod';

export const PointSchema = z.object({
  x: z.number(),
  y: z.number(),
});
export type Point = z.infer<typeof PointSchema>;

export const PointArraySchema = z.array(PointSchema);
export type PointArray = z.infer<typeof PointArraySchema>;

export const PointSiSchema = z.object({
  x: z.number(),
  y: z.number(),
  si: z.number(),
});
export type PointSi = z.infer<typeof PointSiSchema>;

export const PointSiArraySchema = z.array(PointSiSchema);
export type PointSiArray = z.infer<typeof PointSiArraySchema>;
